
<div class="button-tabs">
  <ng-container *ngIf="scrollControl">
    <div *ngIf="arrowLeft" class="button-tabs__arrow left" (click)="scrolling($event, 'left')">
      <img src="assets/arrow-gray-down.svg" alt="arrow-left" />
    </div>
  </ng-container>


  <div #scrollWrap (scroll)="scrollEvent()" class="button-tabs__wrapper h-scrollbar h-scrollbar--hidden">
    <button
      *ngFor="let item of tabsData; index as i; trackBy: trackBy"
      (click)="selectTab(i)"
      class="button-tabs__button"
      [class.active]="i === selectIndex"
    >
      <img
        *ngIf="showIcon"
        src="/assets/{{(item?.sub_unit_floors_attributes | isEvery: 'file')  ? 'circle-check-checked-16-green.svg' : (i === selectIndex ? 'circle-check-checked-16.svg' : 'circle-check-empty-16.svg') }}"
        alt="check icon"
      />
      <span
        class="d-block ellipsis"
        [ngbTooltip]="item[nameKey]"
        [openDelay]="tooltipDelay"
        atlTooltipWidthDisabled
        container="body"
        triggers="hover touchstart"
      >{{item[nameKey]}}</span>
    </button>
  </div>


  <ng-container *ngIf="scrollControl">
    <div *ngIf="arrowRight" class="button-tabs__arrow right" (click)="scrolling($event, 'right')">
      <img src="assets/arrow-gray-down.svg" alt="arrow-right" />
    </div>
  </ng-container>
</div>
